import mod from "-!./Delete.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Delete.js?vue&type=script&lang=js&"